;
define("transaction_line_views_hidden_option.tpl", function(){});

